import parsePhoneNumber, { AsYouType } from 'libphonenumber-js';
export function normalizePhone(phone) {
  return phone?.replace(/\D/g, '') ?? '';
}

export function formatPhoneDisplay(phone) {
  try {
    // const phoneNumber = new AsYouType().input(`+1${phone}`);

    let countryCode = 'US';

    if (phone?.startsWith(0)) {
      countryCode = 'VN';
    }

    // if (phone?.startsWith(1)) {
    //   phone = `${phone}`;
    // }

    const phoneNumber = parsePhoneNumber(`${phone}`, countryCode);
    return phoneNumber?.formatNational() || phone;
  } catch (error) {
    console.log('error', error);
    return phone;
  }
}

export function formatPhoneDisplayUS(phone) {
  try {
    const phoneNumber = new AsYouType().input(`+${phone}`);

    return phoneNumber || phone;
  } catch (error) {
    console.log('error', error);
    return phone;
  }
}

export function isValidURL(string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
}
